/**
 * 产品页属性切换 → 底部购买栏 公共同步
 * - publish: PUB_SUB_EVENTS.variantChange + akaso:variant-change
 * - receive: window.AkasoProductBuyBottom.receive(payload)
 */
(function () {
  function formatMoneyFromCents(cents) {
    if (cents == null) return ""
    try {
      if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents)
      }
    } catch (e) {}
    return (Number(cents) / 100).toFixed(2)
  }

  function getVariants(picker) {
    if (picker && typeof picker.getVariantData === "function") {
      return picker.getVariantData()
    }
    return window.productData?.variants || []
  }

  function findVariantById(variantId, picker) {
    if (!variantId) {
      return null
    }
    return (
      getVariants(picker).find(function (item) {
        return String(item.id) === String(variantId)
      }) || null
    )
  }

  function getPickerOptions(picker) {
    return Array.from(picker.querySelectorAll("select, fieldset"), function (element) {
      if (element.tagName === "SELECT") {
        return element.value
      }
      if (element.tagName === "FIELDSET") {
        const checked = Array.from(element.querySelectorAll('input[type="radio"]')).find(function (radio) {
          return radio.checked
        })
        return checked ? checked.value : null
      }
      return null
    })
  }

  function getCurrentVariantFromPicker(picker) {
    if (!picker) {
      return null
    }

    if (picker.currentVariant) {
      return picker.currentVariant
    }

    const variants = getVariants(picker)
    const options = getPickerOptions(picker)

    if (!variants.length || !options.length) {
      return null
    }

    return (
      variants.find(function (variant) {
        return !variant.options
          .map(function (option, index) {
            return options[index] === option
          })
          .includes(false)
      }) || null
    )
  }

  function resolveVariantFromInput(input, picker) {
    picker = picker || (input && input.closest ? input.closest("variant-selects") : null)
    const sectionId = picker ? picker.dataset.section : null

    if (input && input.dataset && input.dataset.id) {
      const byDataId = findVariantById(input.dataset.id, picker)
      if (byDataId) {
        return {
          variant: byDataId,
          sectionId: sectionId,
          productId: window.productData?.id,
        }
      }
    }

    const currentVariant = getCurrentVariantFromPicker(picker)
    if (currentVariant) {
      return {
        variant: currentVariant,
        sectionId: sectionId,
        productId: window.productData?.id,
      }
    }

    if (sectionId) {
      const formInput = document.querySelector("#product-form-" + sectionId + ' input[name="id"]')
      if (formInput && formInput.value) {
        const byForm = findVariantById(formInput.value, picker)
        if (byForm) {
          return {
            variant: byForm,
            sectionId: sectionId,
            productId: window.productData?.id,
          }
        }
      }
    }

    return null
  }

  function syncToProductBuyBottom(payload) {
    if (!payload || !payload.variant) {
      return false
    }

    if (
      window.AkasoProductBuyBottom &&
      typeof window.AkasoProductBuyBottom.receive === "function"
    ) {
      window.AkasoProductBuyBottom.receive(payload)
      return true
    }

    const root = document.querySelector(".product-buy-bottom")
    if (root && window.Alpine && typeof window.Alpine.$data === "function") {
      const data = window.Alpine.$data(root)
      if (data && typeof data.applyVariant === "function") {
        data.applyVariant(payload.variant, { skipPrice: true })
        if (payload.html && payload.sectionId && typeof data.syncPriceFromVariantHtml === "function") {
          data.syncPriceFromVariantHtml(payload.html, payload.sectionId)
        } else if (typeof data.updatePriceFromDom === "function") {
          data.updatePriceFromDom()
        }
        return true
      }
    }

    return false
  }

  function updateBuyBottomDom(payload) {
    const variant = payload?.variant
    if (!variant) return

    const root = document.querySelector(".product-buy-bottom")
    if (!root) return

    // title
    const titleEl = root.querySelector(".product-nav-info .nav-info-word")
    if (titleEl && variant.title) {
      titleEl.textContent = variant.title
    }

    // image
    const imgEl = root.querySelector(".product-nav-img img.nav-img")
    if (imgEl) {
      const featured = variant.featured_image || variant.featured_media?.preview_image || variant.featured_media
      const src = typeof featured === "string" ? featured : (featured?.src || featured?.url || featured?.preview_image?.src)
      if (src) {
        imgEl.src = src
      }
    }

    // price: only use current variant.price here.
    // Main price DOM and B2B-mutated option labels update asynchronously and can be one click behind.
    const nowPriceEl = root.querySelector(".product-nav-price .now-price")
    if (nowPriceEl) {
      const immediate = formatMoneyFromCents(variant.price)
      if (immediate) nowPriceEl.textContent = immediate
    }
  }

  function publishVariantChange(payload) {
    if (!payload || !payload.variant) {
      return
    }

    const variant = payload.variant
    const sectionId = payload.sectionId
    const productId = payload.productId

    if (window.productData) {
      window.productData.selected_variant = variant
    }

    // 最稳：无论 Alpine 是否工作，都直接更新底部栏 DOM
    try {
      updateBuyBottomDom(payload)
    } catch (e) {
      console.error(e)
    }

    syncToProductBuyBottom(payload)

    if (window.PUB_SUB_EVENTS && typeof window.publish === "function") {
      window.publish(window.PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: sectionId,
          variant: variant,
        },
      })
    }

    document.dispatchEvent(
      new CustomEvent("akaso:variant-change", {
        detail: {
          sectionId: sectionId,
          productId: productId,
          variant: variant,
        },
      })
    )
  }

  window.AkasoOnVariantOptionChange = function (input) {
    const resolved = resolveVariantFromInput(input)
    if (resolved) {
      publishVariantChange(resolved)
    }
  }

  window.AkasoPublishVariantChange = publishVariantChange

  function syncFromPicker(picker, extra) {
    const resolved = resolveVariantFromInput(null, picker)
    if (!resolved) {
      return
    }
    if (extra) {
      Object.assign(resolved, extra)
    }
    publishVariantChange(resolved)
  }

  function bindPicker(picker) {
    if (!picker || picker.dataset.akasoVariantSyncBound === "true") {
      return
    }

    picker.dataset.akasoVariantSyncBound = "true"
    const sectionId = picker.dataset.section
    const productInfo = sectionId ? document.getElementById("ProductInfo-" + sectionId) : null

    picker.addEventListener("change", function (event) {
      const target = event.target
      if (!target) {
        return
      }
      if (target.matches('input[type="radio"]') || target.matches("select")) {
        window.requestAnimationFrame(function () {
          syncFromPicker(picker)
        })
      }
    })

    if (productInfo && productInfo.dataset.akasoVariantSyncBound !== "true") {
      productInfo.dataset.akasoVariantSyncBound = "true"
      productInfo.addEventListener("change", function (event) {
        const target = event.target
        if (!target || !target.matches('input[name="id"]')) {
          return
        }
        const variant = findVariantById(target.value, picker)
        if (variant) {
          publishVariantChange({
            variant: variant,
            sectionId: sectionId,
            productId: window.productData?.id,
          })
        }
      })
    }
  }

  function initAllPickers() {
    document.querySelectorAll("variant-selects[data-section]").forEach(bindPicker)
  }

  // 兜底：URL 变化时同步底部栏（global.js 会更新 ?variant=）
  let lastUrlVariantId = null
  window.setInterval(function () {
    try {
      const url = new URL(window.location.href)
      const vid = url.searchParams.get("variant")
      if (!vid || vid === lastUrlVariantId) return
      lastUrlVariantId = vid

      const picker = document.querySelector("variant-selects[data-section]")
      const variant = findVariantById(vid, picker)
      if (variant) {
        publishVariantChange({
          variant,
          sectionId: picker?.dataset?.section,
          productId: window.productData?.id,
        })
      }
    } catch (e) {}
  }, 300)

  document.addEventListener(
    "click",
    function (event) {
      const pill = event.target.closest ? event.target.closest(".product-form__input--pill") : null
      if (!pill) {
        return
      }
      const picker = pill.closest ? pill.closest("variant-selects") : null
      if (!picker) {
        return
      }
      window.requestAnimationFrame(function () {
        syncFromPicker(picker)
      })
    },
    true
  )

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllPickers)
  } else {
    initAllPickers()
  }

  document.addEventListener("shopify:section:load", initAllPickers)
})()
